/**
 * Shared Tailwind class strings for the Clarity v2 home, header and footer.
 * Kept as plain strings so Tailwind's content scanner picks them up.
 */

/** Calm lift on hover, used by pill buttons. */
export const btnLift =
  "transition-[transform,box-shadow,filter] [transition-duration:400ms] [transition-timing-function:cubic-bezier(.2,.8,.2,1)] hover:-translate-y-px hover:shadow-[0_12px_26px_-12px_hsl(var(--foreground)/0.45)] hover:brightness-[1.06] motion-reduce:transition-none motion-reduce:hover:translate-y-0";

/** Visible keyboard focus on light surfaces. */
export const focusRing =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-primary";

/** Visible keyboard focus on the deep-forest band. */
export const focusRingDark =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-pf-sage";

export const eyebrow =
  "mb-3.5 text-[13px] font-semibold uppercase tracking-[0.08em] text-primary";

/** Display headings: Inter with tight tracking (Inter Tight is not installed). */
export const h2Xl =
  "text-[clamp(38px,5.4vw,76px)] font-bold leading-[1.02] tracking-[-0.035em] text-balance";

export const h2Lg =
  "text-[clamp(36px,4.6vw,64px)] font-bold leading-[1.04] tracking-[-0.035em] text-balance";

export const leadText = "text-[clamp(18px,1.6vw,21px)] leading-[1.45] text-pf-ink2";

export const textLink = `inline-flex min-h-[44px] items-center gap-1.5 font-semibold text-primary hover:underline ${focusRing}`;

export const pill = `inline-flex min-h-[44px] items-center rounded-full border border-foreground/15 bg-background px-[18px] text-[15px] text-foreground transition-colors hover:border-primary hover:bg-white ${focusRing}`;
